export class ActivableModel {

  constructor() {
    this.IsActive = true;
  }

  public IsActive: boolean;

  public CanBeDisabled: boolean;
  
  public CanBeEnabled: boolean;
}
